/**
 * @description 评论获取接口
 * @author duanjun
 */

import Api from '../../../path'
import { fetchData } from '@umu/umu-fetch';

import { CommentParentType, CommentSubjectType, ETagType } from '@umu/umu-types';

export interface IInput {
    parent_type: CommentParentType;
    parent_id: number;
    group_id?: number;
    subject_id?: number;
    subject_type?: CommentSubjectType;
    question_id?: number; // 提问讨论的问题 id
    comment_id?: number; // 父级别id
    depth?: number;
    page?: number;
    size?: number;
    sort_type?: number;
    key_word?: string;
    comment_student_id?: number;
    show_parent_id?: number; // 显示的时候的parentId。需求有些地方需要拍平显示
    status?: number; // 0:审核 1:正常 2:屏蔽
}

export const getCommentList = (data: IInput): Promise<IListResponse<IComment>> => {
    data = Object.assign(
        {
            depth: 1,
            page: 1,
            size: 10,
            sort_type: ETagType.HOTTEST,
            show_parent_id: 0,
        },
        data,
    );
    data.sort_type = data.sort_type || ETagType.HOTTEST;
    return fetchData(Api.GET_COMMENT_LIST, data).then((res: IListResponse<IComment>) => {
        return res;
    });
};
